module.exports = __webpack_public_path__ + "static/media/date-picker.20ea61e8.svg";